export const roles = {
    ADMIN: 'admin',
    AGENCY: 'agency',
    STAFF: 'staff',
    ENDUSER: 'enduser',
    ACCOUNTANT: 'accountant',
    SALE: 'sale',
    CUSTOMER_CARE: 'customer_care',
    TECHNICIAN: 'technician',
    DRIVER: 'driver',
    LEAD_MARKETING: 'lead_marketing'
};

export const roleUsers = [
    // { value_id: 1, name: 'Admin' },
    { value_id: 2, name: 'Nhân viên sale' },
    { value_id: 3, name: 'Nhân viên chăm sóc khách hàng' },
    // { value_id: 4, name: 'Đại lý' },
    { value_id: 5, name: 'Nhân viên' },
    { value_id: 6, name: 'End user' },
    { value_id: 8, name: 'Nhân viên kỹ thuật' },
    { value_id: 10, name: 'Tài xế' },
    { value_id: 11, name: 'Lead Marketing' }
]
